import { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  progress?: number;
  indeterminate?: boolean;
}

export function Button({ progress, indeterminate, ...props }: ButtonProps) {
  return (
    <button className="button relative overflow-hidden" {...props}>
      {props.children}
      {(!!progress || indeterminate) && (
        <progress
          id={`${props.id}-progress`}
          max={1}
          value={progress}
          className="button-progress absolute left-0 right-0 bottom-0 h-1 w-full bg-white bg-opacity-50 indeterminate:animate-pulse"
        >
          {Math.round((progress ?? 0) * 100)}%
        </progress>
      )}
    </button>
  );
}
